import React, { useEffect, useRef } from 'react'
import './evolver.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import useDetailPage from "../../../hooks/useDetailPage";
import { CAT_NAME } from "../../../utils/constant";
import ResponsiveImage from "../../common/ResponsiveImage";
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const Evolve = () => {

    const { posts, loading, singleBlog } = useDetailPage({ blogCount: 3 });

    useEffect(() => {
        gsap.utils.toArray(".evolvecard1").forEach((card) => {
            gsap.fromTo(
                card,
                { scale: 0.5, opacity: 0.2 },
                {
                    scale: 1,
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 100%",
                        end: "top 50%",
                        scrub: false,
                        markers: false
                    },
                }
            );
        });
    }, []);

    return (
        <section className='evolvemainprnt'>
            <div className="custom-container" >
                <div className="evolvechldmain">
                    <div className="headerevolve">
                        <h2>Stay up to date</h2>
                        <Link className='allarticallink secondarybtn' to="/blog">See All</Link>
                    </div>

                </div>
                <div className="overflowautoevolve">

                    {/* <div className="evolvecard" >
                        <div className="evolvecard1">
                            <img className='img-fluid' src="/assets/evolveimg1.png" alt="Blogoneimg" />
                            <h6>Blog</h6>
                            <p>Etiam nulla lectus amet nunc molestie at vulputate.</p>
                        </div>
                       

                    </div> */}
                    {posts.length > 0 ? (
                        <div className="evolvecard">
                            {posts.map((post) => (
                                <div onClick={() => singleBlog(post.slug)} key={post.id} className="evolvecard1">
                                        <ResponsiveImage post={post} className='img-fluid' alt="Blogoneimg" />
                                    <h6>{CAT_NAME[post.categories?.[0]]}</h6>
                                    <p className='truncate-2-lines' dangerouslySetInnerHTML={{ __html: post?.title?.rendered }} />
                                </div>
                            )
                            )}
                        </div>

                    ) : (
                        !loading && <p className="text-center pb-5">No Posts Available.</p>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Evolve